import { defineNuxtPlugin, markRaw } from '#imports';

export default defineNuxtPlugin((nuxtApp: any) => {
  nuxtApp.$pinia.use(({ store }) => {
    store.router = markRaw(nuxtApp.$router);
  });
});
